import { INVALID_PASSCODE } from 'constants/PasscodeModal';

export function invalidPasscode() {
  return {
    type: INVALID_PASSCODE
  };
}

export default {
  invalidPasscode
};
